"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/uploadPicture/index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'UploadFroms',
  components: {
    UploadIndex: _index.default
  },
  props: {
    imgList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isShow: {
      type: Boolean,
      default: true
    },
    limitNum: {
      type: Number,
      default: 9
    },
    itemNum: {
      type: Number,
      default: 1
    },
    isShowTip: {
      type: Boolean,
      default: true
    },
    isDelIcon: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      visible: false,
      callback: function callback() {},
      isMore: '1',
      modelName: 'dental',
      ISmodal: false,
      booleanVal: false,
      maxSizeKB: 0,
      maxSizeErrorMsg: '',
      acceptExts: [],
      acceptErrorMsg: '',
      bothErrorMsg: ''
    };
  },
  methods: {
    openUploadDialog: function openUploadDialog() {
      this.visible = true;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    getImage: function getImage(img) {
      console.log('🔄 上传组件接收到图片数据:', img);

      // 统一数据结构（优先使用服务器返回的可访问地址）
      var list = Array.isArray(img) ? img : [img];
      var normalized = list.map(function (it) {
        return _objectSpread(_objectSpread({}, it), {}, {
          url: it.sattDir || it.attDir || it.url || ''
        });
      });
      console.log('📦 处理后的图片数据:', normalized);

      // 如果有回调函数，调用它
      if (typeof this.callback === 'function') {
        console.log('🎯 调用回调函数...');
        try {
          this.callback(normalized);
          console.log('✅ 回调函数调用成功');
        } catch (error) {
          console.error('❌ 回调函数调用失败:', error);
        }
      } else {
        console.warn('⚠️ 没有找到回调函数');
      }
      this.$emit('getImgData', normalized);
      this.visible = false;
    }
  }
};